import React, { useEffect, useState, Fragment } from 'react';
import Wrapper from '../../components/Wrapper/Wrapper';
import { tripTableHeight, tableHeightWithSparkline } from "../../../styleVariables";
import { DataGrid } from '@material-ui/data-grid';
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import MUIDataTable from "mui-datatables";
import {
  getVendorLedgerData,
} from "../../../store/actions/homeActionCreator";
import * as logger from "../../../logger";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { numberFormat } from '../../../utils/utils'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import useStyles from '../css/listing'
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { useHistory } from 'react-router-dom';
import TopCard from '../../components/TopCard/TopCard';
import { trackDwebEvent } from '../../analytics';
import { Waypoint } from "react-waypoint";
import { debounce } from 'lodash';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../paginationVariables';
const Suppliers = ({ user, dispatchGetVendorLedgerAction, vehicle }) => {
  const classes = useStyles();
  const [vendorLedgerData, setVendorLedgerData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [currentPageNo, setCurrentPageNo] = useState(defaultPageNo);
  const [currentPageSize, setCurrentPageSize] = useState(defaultPageSize);
  const [loadingText, setLoadingText] = useState("Sorry, no Suppliers found");

  const vendorLedgerRequestData = {
    fleetOwnerId: user.userInfo.entityId,
    pageNo: defaultPageNo,
    pageSize: defaultPageSize,
  };
  const onSearchBlur = debounce(query => {
    setVendorLedgerData([]);
    setLoadingText("Loading........");
    setCurrentPageNo(defaultPageNo)
    dispatchGetVendorLedgerAction({ ...vendorLedgerRequestData, searchText: query },
      () => {
        logger.log("Supplier Ledger", "Supplier Ledger Data Loading Success");
        setLoadingText('Sorry, no Suppliers found')
      },
      () => {
        logger.log("Supplier Ledger", "Supplier Ledger Data Loading Failure");
        setLoadingText('Sorry, no Suppliers found');
      }
    );
  }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);
  const getPaginatedData = () => {
    const vendorPaginatedReqData = {
      fleetOwnerId: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
      pageNo: currentPageNo + 1,
      pageSize: currentPageSize,
      searchText: searchText,
      merge: true
    };
    dispatchGetVendorLedgerAction(vendorPaginatedReqData,
      () => {
        logger.log("Supplier Ledger", "Supplier Ledger Data Loading Success");
        setLoadingText('Sorry, no Suppliers found')
      },
      () => {
        logger.log("Supplier Ledger", "Supplier Ledger Data Loading Failure");
        setLoadingText('Sorry, no Suppliers found');
      }
    );
  }
  let history = useHistory();

  useEffect(() => {
    dispatchGetVendorLedgerAction(vendorLedgerRequestData,
      () => {
        logger.log("Supplier Ledger", "Supplier Ledger Data Loading Success");
        setLoadingText('Sorry, no Suppliers found')
      },
      () => {
        logger.log("Supplier Ledger", "Supplier Ledger Data Loading Failure");
        setLoadingText('Sorry, no Suppliers found');
      }
    );
    vehicle.singleTruck = {};
  }, [
    dispatchGetVendorLedgerAction
  ]);
  useEffect(() => {
    if (user.vendorLedgerData) {
      setVendorLedgerData(user.vendorLedgerData);
    }
  }, [user.vendorLedgerData]);

  const buttonCheck = () => {
  }

  const muiColumns = [
    {
      name: "vendorName",
      label: "Supplier Name",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          if (rowIndex === muiData.length - 3) {
            return (
              <Fragment>
                <Waypoint
                  onEnter={() => {
                    if (user && user.suppliersMaxPage && user.suppliersMaxPage != currentPageNo) {
                      getPaginatedData()
                      setCurrentPageNo(currentPageNo + 1)
                    }
                  }}
                />
                {value}
              </Fragment>
            );
          } else {
            return <Fragment>{value}</Fragment>;
          }
        }
      },
    },
    {
      name: "vendorNumber",
      label: "Mobile Number",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{value ? value : 'N/A'}</span>
        }
      },
    },
    {
      name: "activeTripsCount",
      label: "Active Trips",
      options: {
        filter: true,
        sort: false,
      },
    }/*,
    {
      name: "pendingPOD",
      label: "Pending POD's",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span className={classes.color1}>{value ? value : 'N/A'}</span>
        }
      },
    }*/,
    {
      name: "vendorBalance",
      label: "Supplier Balance",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span className={classes.supplierBalance}>{numberFormat(Number(value))}</span>
        }
      },
    }
  ];
  const muiData = vendorLedgerData;
  const options = {
    rowsPerPage: 100,
    pagination: false,
    rowsPerPageOptions: [10, 100, 250],
    filterType: "multiselect",
    fixedHeader: true,
    tableBodyHeight: tableHeightWithSparkline,
    selectableRows: 'none',
    searchOpen: true,
    search: false,
    jumpToPage: false,
    download: false,
    filter: false,
    print: false,
    viewColumns: false,
    onRowClick: (rowData, rowMeta) => {
      handleSupplierRow(rowMeta.dataIndex);
    },
    customToolbar: (data) => {

    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

    },
    searchProps: {
      variant: "outlined",
      //value:searchText,
      InputProps: {
        startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
      },
      onBlur: (e) => {
      },
      onKeyUp: (e) => {
      },
      onKeyDown: (event) => {
        if (event.keyCode === 27) {
        }
      }
    },
    searchPlaceholder: 'Search Supplier',
    onSearchChange: (val) => {
      let value = val ? !val.replace(/\s/g, '').length ? val.trim() : val : "";
      setSearchText(value);
      if (value && value.length > 1) {
        onSearchBlur(value)
      } else if (searchText && value && value.trim().length <= 1) {
        setSearchText("");
        onSearchBlur("")
      }else{
        setSearchText("");
        onSearchBlur("")
      }
    },
    onSearchClose: () => {
    },
    customSearch: (searchQuery, currentRow, columns) => {
      let isFound = false;
      /*if (searchQuery && searchQuery.trim().length > 0) {
        searchQuery= searchQuery.trim()
        currentRow.forEach(col => {
          if (col && col.toString().toUpperCase().indexOf(searchQuery.toUpperCase()) >= 0) {
            isFound = true;
          }
        });
      } else {
        isFound = true;
      }*/
      return true;
    },
    textLabels: {
      body: {
        noMatch: loadingText,
        toolTip: "Sort",
        columnHeaderTooltip: column => `Sort for ${column.label}`
      }
    }
  };

  const handleSupplierRow = (index) => {

    if (index == 0 || index) {
      let vendorId = vendorLedgerData[index].id;
      let vendorName = vendorLedgerData[index].vendorName;
      trackDwebEvent("", {
        "supplier_id": vendorId,
        "supplier_name": vendorName
      });
      history.push({
        pathname: `/suppliers/single-supplier/trips/${vendorId}`,
        state: {
          id: 8,
          pageTitle: vendorName ? vendorName : 'Vendor View',
          vendorId: vendorId
        }
      });
    }
  }

  return (<Wrapper>
    <Paper className={classes.pageContentDIv} elevation={3}>
      <Grid container justify="flex-start" spacing={3} direction="row" alignItems="center">
        <Grid item>
          <TopCard title='Total Supplier Balance' infoTitle='Total Supplier Balance' infoText='The total balance amount to be paid to all your suppliers'
            color="#de1c22" infoIcon={true} cardValue={numberFormat(user.totalRemainingAmountVendorLedger ? user.totalRemainingAmountVendorLedger : 0)} />
        </Grid>
        <Grid item>
          <TopCard title='Active Market Trips' infoTitle='Active Market Trips' infoText='The total number of trips with a balance amount to supplier' color="#00875a" infoIcon={true} cardValue={user.activeTripCountVendorLedger ? user.activeTripCountVendorLedger : 0} />
        </Grid>
        {/* <Grid item>
          <Paper className={classes.infoCard} >
            <Typography variant="subtitle2" className={classes.infoCardTitle}>
              POD'S PENDING
              <InfoOutlinedIcon className={classes.infoCardIcon} />
            </Typography>
            <Typography variant="subtitle2" className={classes.infoActiveSupplier}>
              {user.activeTripCount ? user.activeTripCount : 0}
            </Typography>
          </Paper>
        </Grid> */}
      </Grid>
      <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
    </Paper>
    {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid rows={rows} columns={columns} pageSize={5} checkboxSelection />
    </div> */}
  </Wrapper>);
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchLogoutAction: () => dispatch(logoutUser()),
  dispatchGetVendorLedgerAction: (requestData, onSuccess, onError) => {
    dispatch(getVendorLedgerData(requestData, onSuccess, onError))
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Suppliers);